import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDownLeftCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.636 13.678A8 8 0 1 0 2.365 2.322a8 8 0 0 0 11.27 11.356m-8.83-2.508l.021-5.657l1.41 1.42l2.838-2.818l2.818 2.839l-2.84 2.818l1.41 1.42z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDownLeftCircle
